module.exports = __webpack_public_path__ + "img/MGH-Gaien-4-2440x1172.89a1e957.jpg";